import type { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

export const Td = <T extends string>({
  id,
  title,
  children,
  className,
}: {
  id?: T
  title?: string
  children?: ReactNode
  className?: string
}) => (
  <td id={id} title={title} className={twMerge('p-2 md:p-4', className)}>
    {children}
  </td>
)
